import { useQuery } from "@tanstack/react-query"
import {
  emailReaderCompaniesQuery,
  emailReaderMessagesQuery,
  emailReaderThreadQuery,
} from "modules/backoffice/lib/emailReader/emailReaderQueries"

export function useEmailReaderCompaniesQuery(
  ...args: Parameters<typeof emailReaderCompaniesQuery>
) {
  return useQuery(emailReaderCompaniesQuery(...args))
}

export function useEmailReaderMessagesQuery(...args: Parameters<typeof emailReaderMessagesQuery>) {
  return useQuery(emailReaderMessagesQuery(...args))
}

export function useEmailReaderThreadQuery(...args: Parameters<typeof emailReaderThreadQuery>) {
  return useQuery(emailReaderThreadQuery(...args))
}
